// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__19Jo4","addWidgetButton":"Header_addWidgetButton__2D-lY","dashboardTabs":"Header_dashboardTabs__2J5ok","active":"Header_active__1Dmuj"};